if (document.querySelector('[data-loyalty-rewards-section]')) {
  // DOM elements
  var loyaltyRewardsSection = document.querySelector('[data-loyalty-rewards-section]');
  var loggedInHeroRedeemBtn = document.querySelector('[data-lr-logged-in-hero-redeem-btn]');
  var earnLoyaltyRewardsMainContent = loyaltyRewardsSection.querySelector('[data-lr-elr-main-content]');
  var earnLoyaltyRewardsFooter = loyaltyRewardsSection.querySelector('[data-lr-elr-footer]');
  var earningPointsMainContent = loyaltyRewardsSection.querySelector('[data-lr-ep-main-content]');
  var takeActionsLoginBtn = loyaltyRewardsSection.querySelector('[data-lr-ta-login-btn]');
  var takeActionsSignupBtn = loyaltyRewardsSection.querySelector('[data-lr-ta-signup-btn]');
  var loggedInHeroSection = loyaltyRewardsSection.querySelector('[data-lr-logged-in-hero-section]');
  var loyaltyRewardsLottiePlayer = loggedInHeroSection?.querySelector('[data-lr-lottie]');
  var lrLoggedInUserPointsCount = loggedInHeroSection?.querySelector('[data-lr-logged-in-hero-points-count]');
  var lrLoggedInUserRedeemNowBtn = loggedInHeroSection?.querySelector('[data-lr-logged-in-hero-redeem-btn]');

  var loyaltyRewardsLottieFileUrl =
    window.innerWidth > 1300
      ? loyaltyRewardsLottiePlayer?.dataset.src
      : loyaltyRewardsLottiePlayer?.dataset.srcMobile;

  // if (document.querySelector('[data-lr-logged-in-hero-section]')) {
  //   var lrLoggedInHeroSection = document.querySelector('[data-lr-logged-in-hero-section]');
  //   lazyLoadSectionFiles(
  //     lrLoggedInHeroSection,
  //     lrLoggedInHeroSection.querySelectorAll('[data-lazy-loading-image]'),
  //     undefined,
  //     [{ lottiePlayer: loyaltyRewardsLottiePlayer, lottieFileName: loyaltyRewardsLottieFileUrl }]
  //   );
  // }

  // if (document.querySelector('[data-lr-not-logged-in-hero-section]')) {
  //   var lrNotLoggedInHeroSection = document.querySelector('[data-lr-not-logged-in-hero-section]');
  //   lazyLoadSectionFiles(
  //     lrNotLoggedInHeroSection,
  //     lrNotLoggedInHeroSection.querySelectorAll('[data-lazy-loading-image]'),
  //     undefined,
  //     undefined
  //   );
  // }

  // if (document.querySelector('[data-lr-earn-loyalty-rewards]')) {
  //   var lrEarnLoyaltyRewardsSection = document.querySelector('[data-lr-earn-loyalty-rewards]');
  //   lazyLoadSectionFiles(
  //     lrEarnLoyaltyRewardsSection,
  //     lrEarnLoyaltyRewardsSection.querySelectorAll('[data-lazy-loading-image]'),
  //     undefined,
  //     undefined
  //   );
  // }

  loggedInHeroRedeemBtn && loggedInHeroRedeemBtn.addEventListener('click', function (e) {
    e.preventDefault();
    window.location.href += '#appstle-loyalty';
  });

  if (document.querySelector('[data-lr-direct-selling-only]')) {
    var lrDirectSellingOnlySection = document.querySelector('[data-lr-direct-selling-only]');
    lazyLoadSectionFiles(
      lrDirectSellingOnlySection,
      lrDirectSellingOnlySection.querySelectorAll('[data-lazy-loading-image]'),
      undefined,
      undefined
    );
  }

  if (document.querySelector('[data-lr-skip-supply-house]')) {
    var lrSkipSupplyHouseSection = document.querySelector('[data-lr-skip-supply-house]');
    lazyLoadSectionFiles(
      lrSkipSupplyHouseSection,
      lrSkipSupplyHouseSection.querySelectorAll('[data-lazy-loading-image]'),
      undefined,
      undefined
    );
  }

  if (document.querySelector('[data-lr-main-content-divider]')) {
    var lrMainContentDivider = document.querySelector('[data-lr-main-content-divider]');
    lazyLoadSectionFiles(
      lrMainContentDivider,
      lrMainContentDivider.querySelectorAll('[data-lazy-loading-image]'),
      undefined,
      undefined
    );
  }

  if (document.querySelector('[data-lr-earning-points]')) {
    var lrEarningPointsSection = document.querySelector('[data-lr-earning-points]');
    lazyLoadSectionFiles(
      lrEarningPointsSection,
      lrEarningPointsSection.querySelectorAll('[data-lazy-loading-image]'),
      undefined,
      undefined
    );
  }

  if (document.querySelector('[data-lr-take-actions]')) {
    var lrTakeActionsSection = document.querySelector('[data-lr-take-actions]');
    lazyLoadSectionFiles(
      lrTakeActionsSection,
      lrTakeActionsSection.querySelectorAll('[data-lazy-loading-image]'),
      undefined,
      undefined
    );
  }

  // variables
  var onloadTransitionDurationLonger = 500;
  var onloadTransitionDurationShorter = 300;
  var onloadTransitionDelayStepShorter = 130;
  var onloadTransitionDelayStepLarger = 200;

  // assign transition delays to the each row of specific side-by-side list
  var elrLastIndexNotApplied = assignTransitionDelays(
    earnLoyaltyRewardsMainContent,
    3,
    onloadTransitionDelayStepShorter
  );
  earnLoyaltyRewardsFooter.style.transitionDelay = `${
    elrLastIndexNotApplied * onloadTransitionDelayStepShorter + onloadTransitionDelayStepLarger
  }ms`;
  assignTransitionDelays(earningPointsMainContent, 3, onloadTransitionDelayStepShorter);


  document.addEventListener('DOMContentLoaded', () => {
    // logged-in hero section loading animation
    if (loyaltyRewardsSection.dataset.userLoggedIn === 'true') {
      playLoadingAnimationsBySection(
        '[data-lr-logged-in-hero-section]',
        ['[data-lr-logged-in-hero-bg]'],
        0.3
      );
    }

    // not-logged-in hero section loading animation
    playLoadingAnimationsBySection(
      '[data-lr-not-logged-in-hero-section]',
      [
        '[data-lr-not-logged-in-hero-sup-title]',
        '[data-lr-not-logged-in-hero-main-title]',
        '[data-lr-not-logged-in-hero-subtitle]',
        '[data-lr-not-logged-in-hero-shiny-diamond]'
      ],
      0.3
    );

    // earn loyalty rewards section loading animation
    playLoadingAnimationsBySection(
      '[data-lr-earn-loyalty-rewards]',
      [
        '[data-lr-elr-main-content]',
        '[data-lr-sbs-list-row]',
        '[data-lr-elr-main-title]',
        '[data-lr-elr-subtitle]',
        '[data-lr-elr-footer]'
      ],
      0.3
    );
  });

  if (typeof checkImagesLoaded !== 'undefined') {
    checkImagesLoaded('[data-loyalty-rewards-section]', playAnimationsAfterImagesLoaded);
  } else {
    playAnimationsAfterImagesLoaded();
  }


  function playAnimationsAfterImagesLoaded() {
    // direct selling only section loading animation
    playLoadingAnimationsBySection(
      '[data-lr-direct-selling-only]',
      ['[data-lr-dso-title]', '[data-lr-dso-drawing]'],
      0.3
    );

    // skip supply house section loading animation
    playLoadingAnimationsBySection(
      '[data-lr-skip-supply-house]',
      [
        '[data-lr-ssh-bpbi-border]',
        '[data-lr-ssh-bpbi-caption]',
        '[data-lr-ssh-tsh-caption]',
        '[data-lr-ssh-skip-caption]',
        '[data-lr-ssh-super-tasty-caption]',
        '[data-lr-ssh-smile]'
      ],
      0.3
    );

    // earning points section loading animation
    playLoadingAnimationsBySection(
      '[data-lr-earning-points]',
      ['[data-lr-ep-main-title]', '[data-lr-ep-subtitle]', '[data-lr-sbs-list-row]'],
      0.2
    );

    // earning points section footer loading animation
    if (loyaltyRewardsSection.dataset.userLoggedIn !== 'true') {
      playLoadingAnimationsBySection(
        '[data-lr-ep-footer]',
        [
          '[data-lr-ep-footer-other-ways-to-earn]',
          '[data-lr-ep-footer-smile-points-caption]',
          '[data-lr-ep-footer-arrow-down]',
          '[data-lr-ep-footer-arrow-additions]'
        ],
        0.3
      );
    }

    // take actions section loading animation
    if (loyaltyRewardsSection.dataset.userLoggedIn !== 'true') {
      playLoadingAnimationsBySection(
        '[data-lr-take-actions]',
        ['[data-lr-ta-login-btn]', '[data-lr-ta-signup-btn]'],
        0.4,
        700,
        () => {
          removeTransitionDelay(takeActionsLoginBtn);
          removeTransitionDelay(takeActionsSignupBtn);
        }
      );
    }
  }

  function playLoadingAnimationsBySection(
    sectionSelector,
    elementsSelectors,
    thresholdValue,
    delayDuration,
    delayedFunc
  ) {
    const section = loyaltyRewardsSection.querySelector(sectionSelector);
    const sectionElements = getDOMElementsFromSelectors(section, elementsSelectors);

    const sectionIntersectionObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            sectionElements.forEach(element => element.classList.add('animate-in'));

            if (delayDuration && delayedFunc) {
              setTimeout(delayedFunc, delayDuration);
            }

            sectionIntersectionObserver.unobserve(section);
          }
        });
      },
      { threshold: thresholdValue }
    );
    sectionIntersectionObserver.observe(section);
  }

  function getDOMElementsFromSelectors(parentElement, elementsSelectors) {
    let DOMElements = [];
    for (let i = 0; i < elementsSelectors.length; i++) {
      const elements = [...parentElement.querySelectorAll(elementsSelectors[i])];
      if (!elements) continue;

      DOMElements = [...DOMElements, ...elements];
    }

    return DOMElements;
  }

  // assigns transition delays to the each row of specific side-by-side list
  function assignTransitionDelays(containerOfSideBySideList, startingDelayIndex, delayStep) {
    const sideBySideList = containerOfSideBySideList.querySelectorAll('[data-lr-sbs-list-row]');
    for (let i = 0; i < sideBySideList.length; i++) {
      sideBySideList[i].style.transitionDelay = `${(startingDelayIndex + i) * delayStep}ms`;
    }

    return startingDelayIndex + sideBySideList.length - 1;
  }

  // removes transition delay from certain element
  function removeTransitionDelay(element) {
    element.classList.add('transition-delay-0');
  }

  // lottie
  let sectionWasAlreadyInViewport = false;
  let isFirstTime = true;

  function reloadPlayer(player) {
    player.load(loyaltyRewardsLottieFileUrl);

    player.addEventListener('ready', () => {
      player.play();
      player.setSpeed(2.4);
    });

    player.addEventListener('complete', () => {
      if (isFirstTime) {
        // lrLoggedInUserPointsCount.classList.add("animate-in");
        lrLoggedInUserRedeemNowBtn.classList.add('animate-in');

        setTimeout(() => {
          removeTransitionDelay(loggedInHeroRedeemBtn);
        }, onloadTransitionDurationLonger);

        isFirstTime = false;
      }
    });
  }

  if (loyaltyRewardsLottiePlayer) {
    document.addEventListener('DOMContentLoaded', handleLottieAnimation);
    // checkImagesLoaded('[data-loyalty-rewards-section]', handleLottieAnimation);
    window.addEventListener('scroll', handleLottieAnimation);
  }

  function handleLottieAnimation() {
    if (isSectionInViewPort(loggedInHeroSection) && sectionWasAlreadyInViewport === false) {
      sectionWasAlreadyInViewport = true;
      reloadPlayer(loyaltyRewardsLottiePlayer);
    }
    if (!isSectionInViewPort(loggedInHeroSection)) {
      sectionWasAlreadyInViewport = false;
    }
  }
}

function isSectionInViewPort(sectionElement) {
  const currentScroll = document.documentElement.scrollTop;
  const sectionScrollTop = getElementsScrollTop(sectionElement);
  const scrollInsideSection = currentScroll - sectionScrollTop;

  const sectionHeight = sectionElement.getBoundingClientRect().height;
  const sectionTopDistanceFromEdge = sectionElement.getBoundingClientRect().top;

  if (sectionTopDistanceFromEdge > 0) return scrollInsideSection > 0;

  return scrollInsideSection > 0 && Math.abs(sectionTopDistanceFromEdge) - sectionHeight < 0;
}

function getElementsScrollTop(element) {
  const topDistanceFromViewport = element.getBoundingClientRect().top;
  const windowScrollTop = document.documentElement.scrollTop;
  const windowHeight = window.innerHeight;
  return topDistanceFromViewport + windowScrollTop - windowHeight;
}

function getCSSPropertyValueFromRoot(propertyName) {
  const root = document.querySelector(':root');
  const rootStyles = getComputedStyle(root);
  return rootStyles.getPropertyValue(propertyName);
}
